import React from "react";
import { Plan } from "../../types/plans/plan";
import { CardHeading } from "./CardHeading";
import { PlanAccount } from "./PlanAccount";
import { StdPlanText } from "./StdPlanText";
import { UnlockPlanOrAlternative } from "./UnlockPlanOrAlternative";
import { UpsellCardBase } from "./UpsellCardBase";
import { useUpsellAnalytics } from "./useUpsellAnalytics";

export const EntityPlanCard = ({
  recommendedPlan,
  cheaperPlan,
  currentPlan,
  account,
}: {
  recommendedPlan: Plan;
  cheaperPlan: Plan;
  currentPlan: Plan | undefined;
  account: PlanAccount;
}) => {
  useUpsellAnalytics(account.accountType, recommendedPlan.name);

  return (
    <UpsellCardBase
      heading={
        <CardHeading>
          {currentPlan ?
            `Unlock ${account.accountType} account`
          : "Get your tax report"}
        </CardHeading>
      }
      content={
        <StdPlanText
          recommendedPlan={recommendedPlan}
          currentPlan={currentPlan}
          account={account}
          subtext={`Get your ${account.accountType} crypto tax report.`}
        />
      }
      actions={
        <UnlockPlanOrAlternative
          account={account}
          currentPlan={currentPlan}
          recommendedPlan={recommendedPlan}
          cheaperPlan={cheaperPlan}
        />
      }
    />
  );
};
